var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.75V3C6.00173 2.4038 6.23934 1.8325 6.66092 1.41092C7.0825 0.98934 7.6538 0.751731 8.25 0.75H18.75C19.3462 0.751731 19.9175 0.98934 20.3391 1.41092C20.7607 1.8325 20.9983 2.4038 21 3V20.25L17.25 17.25",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.5H5.25C4.6538 4.50173 4.0825 4.73934 3.66092 5.16092C3.23934 5.5825 3.00173 6.1538 3 6.75V23.25L10.125 17.25L17.25 23.25V6.75C17.2483 6.1538 17.0107 5.5825 16.5891 5.16092C16.1675 4.73934 15.5962 4.50173 15 4.5V4.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkOutline);
export default __webpack_public_path__ + "static/media/BookmarkOutline.5f561dc2a03dd3144600aecd2f02c3df.svg";
export { ForwardRef as ReactComponent };